import { Pipe, PipeTransform } from '@angular/core';
import { defaultTenantDateFormats, TenantDateFormats } from '../../core/services/tenant-formatting.service';
import { formatAppDate } from '../../core/utils/app-date-formatter';
@Pipe({
  name: 'appDate',
  standalone: true
})
export class AppDatePipe implements PipeTransform {
  transform(value?: Date | string | number | null, kind: 'date' | 'time' | 'dateTime' | 'dayKey' = 'date', formats: TenantDateFormats = defaultTenantDateFormats): string {
    const pattern = kind === 'dayKey' ? 'yyyy-MM-dd' : kind === 'time' ? formats.timeFormat : kind === 'dateTime' ? formats.dateTimeFormat : formats.dateFormat;
    return formatAppDate(value, pattern);
  }
}
